import { Link, useLocation } from "react-router-dom";
import { Map, Calendar } from "lucide-react";

/**
 * Floating Action Button — bottom-right, persistent across public pages.
 * Hides itself when already on /map-schedule to avoid self-link clutter.
 */
export const MapScheduleFab = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/festival-info/map-schedule")) return null;
  return (
    <Link
      to="/festival-info/map-schedule"
      data-testid="map-schedule-fab"
      aria-label="Map & Schedule"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 bg-[#E5247C] text-white kf-border px-4 py-3 hover:bg-[#FFB400] hover:text-[#3D1E6D] transition-colors"
      style={{ boxShadow: "5px 5px 0 #3D1E6D" }}
    >
      <span className="relative flex items-center">
        <Map className="h-5 w-5" />
        <Calendar className="h-3.5 w-3.5 absolute -bottom-1 -right-1 bg-[#FFB400] text-[#3D1E6D] kf-border p-[1px]" />
      </span>
      <span className="text-xs font-bold uppercase tracking-widest hidden sm:inline">Map &amp; Schedule</span>
    </Link>
  );
};
